import React from 'react'
import { Link } from 'react-scroll'
import styles from "./Css/Navbar.module.css"

const Navbar = () => {
    
    return (
        <div className={styles.navbar}>
            <div >
                <h1 className={styles.navbar__name}>Aejaz Ahmed</h1>
            </div>
            <ul className={styles.navbar__links}>
                
                <li> <Link to="about" activeClass="active" smooth={true} offset={-100}>About me</Link></li>
                {/* <li><Link to="techstack" activeClass="active" smooth={true} offset={-2010}>Tech Stack</Link></li> */}
                <li><Link to="projects" activeClass="active" smooth={true} offset={-100}>Projects</Link></li>
                <li><Link to="contact" activeClass="active" smooth={true} offset={-50}>Contact</Link></li>
            </ul>
        </div>
    )
}

export { Navbar }
